import { defineMessages } from 'react-intl';

export const dataType = defineMessages({
  'dt:data_type:text': {
    id: 'data_type.text.title',
    defaultMessage: 'Text',
    value: 'text',
  },
  'dt:data_type:decimal1': {
    id: 'data_type.decimal1.title',
    defaultMessage: 'Decimal (1.0)',
    value: 'decimal1',
  },
  'dt:data_type:decimal2': {
    id: 'data_type.decimal2.title',
    defaultMessage: 'Decimal (1.00)',
    value: 'decimal2',
  },
  'dt:data_type:decimal3': {
    id: 'data_type.decimal3.title',
    defaultMessage: 'Decimal (1.000)',
    value: 'decimal3',
  },
  'dt:data_type:decimal4': {
    id: 'data_type.decimal4.title',
    defaultMessage: 'Decimal (1.0000)',
    value: 'decimal4',
  },
  'dt:data_type:decimal5': {
    id: 'data_type.decimal5.title',
    defaultMessage: 'Decimal (1.00000)',
    value: 'decimal5',
  },
  'dt:data_type:decimal6': {
    id: 'data_type.decimal6.title',
    defaultMessage: 'Decimal (1.000000)',
    value: 'decimal6',
  },
  'dt:data_type:integer': {
    id: 'data_type.integer.title',
    defaultMessage: 'Integer',
    value: 'integer',
  },
  'dt:data_type:date': {
    id: 'data_type.date.title',
    defaultMessage: 'Date',
    value: 'date',
  },
  'dt:data_type:date_time': {
    id: 'data_type.date_time.title',
    defaultMessage: 'Date-time',
    value: 'date_time',
  },
  'dt:data_type:time': {
    id: 'data_type.time.title',
    defaultMessage: 'Time',
    value: 'time',
  },
  'dt:data_type:boolean_icon': {
    id: 'data_type.boolean_icon.title',
    defaultMessage: 'Boolean (icon)',
    value: 'boolean_icon',
  },
  'dt:data_type:boolean_text': {
    id: 'data_type.boolean_text.title',
    defaultMessage: 'Boolean (text)',
    value: 'boolean_text',
  },
  'dt:data_type:link': {
    id: 'data_type.link.title',
    defaultMessage: 'Link',
    value: 'link',
  },
  // @TODO - Future use
  // 'dt:data_type:currency': {
  //   id: 'data_type.currency.title',
  //   defaultMessage: 'Currency',
  //   value: 'currency',
  // },
});